export default __webpack_public_path__ + "5a23c9975b130bca5e675c779489b7fc.png";